import "./GchGalleryStyles.css";
import motherLang1 from "../Assets/Gallery/MotherLanguage/motherLang-1.jpg";
import motherLang2 from "../Assets/Gallery/MotherLanguage/motherLang-2.jpg";
import motherLang3 from "../Assets/Gallery/MotherLanguage/motherLang-3.jpg";
import motherLang4 from "../Assets/Gallery/MotherLanguage/motherLang-4.jpg";
import motherLang5 from "../Assets/Gallery/MotherLanguage/motherLang-5.jpg";
import motherLang6 from "../Assets/Gallery/MotherLanguage/motherLang-6.jpg";
import motherLang7 from "../Assets/Gallery/MotherLanguage/motherLang-7.jpg";
import motherLang8 from "../Assets/Gallery/MotherLanguage/motherLang-8.jpg";
import motherLang9 from "../Assets/Gallery/MotherLanguage/motherLang-9.jpg";
import retailAwareness1 from "../Assets/Gallery/RetailAwareness/retailSecurity-1.jpg";
import retailAwareness2 from "../Assets/Gallery/RetailAwareness/retailSecurity-2.jpg";
import retailAwareness3 from "../Assets/Gallery/RetailAwareness/retailSecurity-3.jpg";
import retailAwareness4 from "../Assets/Gallery/RetailAwareness/retailSecurity-4.jpg";
import retailAwareness5 from "../Assets/Gallery/RetailAwareness/retailSecurity-5.jpg";
import retailAwareness6 from "../Assets/Gallery/RetailAwareness/retailSecurity-6.jpg";
import retailAwareness7 from "../Assets/Gallery/RetailAwareness/retailSecurity-7.jpg";
import retailAwareness8 from "../Assets/Gallery/RetailAwareness/retailSecurity-8.jpg";
import retailAwareness9 from "../Assets/Gallery/RetailAwareness/retailSecurity-9.jpg";
import retailAwareness10 from "../Assets/Gallery/RetailAwareness/retailSecurity-10.jpg";
import retailAwareness11 from "../Assets/Gallery/RetailAwareness/retailSecurity-11.jpg";
import retailAwareness12 from "../Assets/Gallery/RetailAwareness/retailSecurity-12.jpg";
import retailAwareness13 from "../Assets/Gallery/RetailAwareness/retailSecurity-13.jpg";
import retailAwareness14 from "../Assets/Gallery/RetailAwareness/retailSecurity-14.jpg";

function MotherLanguageDay() {
  return (
    <div className="gallery-container">
      <div className="GCH-event-activity-heading">
        <h4>International Mother Language Day (2019)</h4>
      </div>
      <div className="GCH-event-activity-gallery">
        <div>
          <img alt="child-image" src={motherLang1} />
          <img alt="child-image" src={motherLang2} />
          <img alt="child-image" src={motherLang3} />
        </div>
        <div>
          <img alt="child-image" src={motherLang4} />
          <img alt="child-image" src={motherLang5} />
          <img alt="child-image" src={motherLang6} />
        </div>
        <div>
          <img alt="child-image" src={motherLang7} />
          <img alt="child-image" src={motherLang8} />
          <img alt="child-image" src={motherLang9} />
        </div>
      </div>

      <div className="GCH-event-activity-heading">
        <h4>Retail Security Awareness Training (2019)</h4>
      </div>
      <div className="GCH-event-activity-gallery">
        <div>
          <img alt="child-image" src={retailAwareness1} />
          <img alt="child-image" src={retailAwareness2} />
          <img alt="child-image" src={retailAwareness3} />
          <img alt="child-image" src={retailAwareness4} />
          <img alt="child-image" src={retailAwareness5} />
        </div>
        <div>
          <img alt="child-image" src={retailAwareness6} />
          <img alt="child-image" src={retailAwareness7} />
          <img alt="child-image" src={retailAwareness8} />
          <img alt="child-image" src={retailAwareness9} />
        </div>
        <div>
          <img alt="child-image" src={retailAwareness10} />
          <img alt="child-image" src={retailAwareness11} />
          <img alt="child-image" src={retailAwareness12} />
          <img alt="child-image" src={retailAwareness13} />
          <img alt="child-image" src={retailAwareness14} />
        </div>
      </div>
    </div>
  );
}

export default MotherLanguageDay;
